import script from "./MailerSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailerSettings.vue?vue&type=script&setup=true&lang=ts"

import "./MailerSettings.vue?vue&type=style&index=0&id=133e57bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133e57bf"]])

export default __exports__